module.exports = __webpack_public_path__ + "img/ico-visual-platform_1.c6bf2808.svg";